import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { intlShape, injectIntl } from 'react-intl';

import Loading from '../../dialogs/loading';
import * as actions from '../../../actions/onboarding.actions';

import Welcome from './welcome';
import Steps from './steps';
import End from './end';
import Client from './client';
import Locals from './locals';
import Team from './team';
import Permissions from './permissions';
import Users from './users';
import Employees from './employees';
import Covid from './covid';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
            onboarding: undefined,
            info: undefined,
            quotaLocales: undefined,
            step: 0
        }
        props.load(props.id);
        props.loadPermission();
    }

    static getDerivedStateFromProps(props, state) {
        const { onboarding } = props;
        if (onboarding !== state.info) {
            state.info = onboarding;
            state.onboarding = onboarding.onboardingData;
            state.step = onboarding && onboarding.paso ? onboarding.paso : 0;
            state.quotaLocales = onboarding && onboarding.quotaLocales && onboarding.quotaLocales !== -1 ? onboarding.quotaLocales : undefined;
            state.quotaProcesos = onboarding && onboarding.quotaProcesos && onboarding.quotaProcesos !== -1 ? onboarding.quotaProcesos : undefined;
            state.quotaUsuarios = onboarding && onboarding.quotaUsuarios && onboarding.quotaUsuarios !== -1 ? onboarding.quotaUsuarios : undefined;
            return state;
        }
        return null;
    }

    handleNext = (event) => {
        this.goto(this.state.step + 1)
    }

    handlePrevious = (event) => {
        this.goto(this.state.step - 1)
    }

    handleGoTo = (step) => event => {
        this.goto(step)
    }

    goto = step => {
        const info = this.state.info
        info.paso = step;
        info.onboardingData = this.state.onboarding;
        this.props.putOnboarding(this.props.id, info);
        this.setState({ step: step })
    }

    handleDownload = event => {

    }

    handleSave = (name, value) => {
        const { onboarding } = this.state;
        onboarding[name] = value;
        this.setState({ onboarding: onboarding })
    }

    render() {
        const { onboarding, error, step, quotaProcesos, quotaLocales, quotaUsuarios, info } = this.state;
        const { info_is_loading } = this.props;
        console.log("quotaLocales", quotaLocales, this.state.info)
        const steps = [
            {
                label: 'ob_logo',
                step: 1,
                component: <Client
                    {...this.props}
                    key={"step-1"}
                    label={'ob_logo'}
                    onboarding={onboarding}
                    onSave={this.handleSave}
                    onPrevious={this.handlePrevious}
                    goTo={this.handleGoTo}
                    onNext={this.handleNext}
                />
            },
            {
                label: 'ob_locals',
                step: 2,
                component: <Locals
                    {...this.props}
                    key={"step-2"}
                    label={'ob_locals'}
                    quota={quotaLocales}
                    idiomas={info.idiomas ? info.idiomas.map((t) => { return { label: t.nombre, value: t.id } }) : []}
                    timezones={info.timezones ? info.timezones.map((t) => { return { label: t.nombre, value: t.id } }) : []}
                    paises={info.paises ? info.paises.map((t) => { return { label: t.nombre, value: t.id } }) : []}
                    onboarding={onboarding}
                    onSave={this.handleSave}
                    onPrevious={this.handlePrevious}
                    goTo={this.handleGoTo}
                    onNext={this.handleNext}
                />
            },
            {
                label: 'ob_structure',
                step: 3,
                component: <Team
                    {...this.props}
                    key={"step-3"}
                    label={'ob_structure'}
                    onboarding={onboarding}
                    onSave={this.handleSave}
                    onPrevious={this.handlePrevious}
                    goTo={this.handleGoTo}
                    onNext={this.handleNext}
                />
            },
            {
                label: 'ob_permissions',
                step: 4,
                component: <Permissions
                    {...this.props}
                    key={"step-4"}
                    label={'ob_permissions'}
                    onboarding={onboarding}
                    onSave={this.handleSave}
                    onPrevious={this.handlePrevious}
                    goTo={this.handleGoTo}
                    onNext={this.handleNext}
                />
            },
            {
                label: 'ob_users',
                step: 5,
                component: <Users
                    {...this.props}
                    key={"step-5"}
                    label={'ob_users'}
                    quota={quotaUsuarios}
                    onboarding={onboarding}
                    onSave={this.handleSave}
                    onPrevious={this.handlePrevious}
                    goTo={this.handleGoTo}
                    onNext={this.handleNext}
                />
            },
            {
                label: 'ob_employees',
                step: 6,
                component: <Employees
                    {...this.props}
                    key={"step-6"}
                    label={'ob_employees'}
                    onboarding={onboarding}
                    onSave={this.handleSave}
                    onPrevious={this.handlePrevious}
                    goTo={this.handleGoTo}
                    onNext={this.handleNext}
                />

            },
            {
                label: 'ob_covid',
                step: 7,
                component: <Covid
                        {...this.props}
                        key={"step-7"}
                        label={'ob_covid'}
                        quota={quotaProcesos}
                        procesos={info.procesos}
                        onboarding={onboarding}
                        onSave={this.handleSave}
                        onPrevious={this.handlePrevious}
                        goTo={this.handleGoTo}
                        onNext={this.handleNext}
                    />
            }
        ]

        const valids = [
                        onboarding
                        && onboarding.nombre 
                        && onboarding.logo, 
                        onboarding
                        && onboarding.locales
                        && onboarding.locales.length > 0, 
                        onboarding
                        && onboarding.roles
                        && onboarding.roles.length > 0, 
                        onboarding
                        && onboarding.permisos
                        && onboarding.permisos.length > 0, 
                        onboarding
                        && onboarding.usuarios
                        && onboarding.usuarios.length > 0,
                        onboarding
                        && onboarding.trabajadores
                        && onboarding.trabajadores.length > 0, 
                        false
                    ];
        return (
            <div className="bodyonboarding">
                {info_is_loading && <Loading open opacity />}
                {(step === 0 && !error) && <Welcome {...this.props} onNext={this.handleNext} />}
                {(step !== 0 && step < 8 && !error) &&
                    <div className="flex_full_row height100 width100">
                        <Steps
                            {...this.props}
                            steps={steps}
                            step={step}
                            valids={valids}
                            onPrevious={this.handlePrevious}
                            goTo={this.handleGoTo}
                        />
                        {
                            steps.reduce((arr, item) => {
                                if (item.step === step) {
                                    arr.push(item.component);
                                }
                                return arr;
                            }, [])
                        }
                    </div>
                }
                {(step === 8 && !error) && <End
                    {...this.props}
                    onDownload={this.handleDownload}
                    onNext={this.handleNext}
                />}
            </div>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired
};

function mapStateToProps(state) {
    return {
        onboarding_permission: state.onboarding_permission,
        onboarding: state.onboarding,
        onboarding_has_errored: state.onboarding_has_errored,
        info_is_loading: state.info_is_loading
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/onboarding/index.js